import React from 'react';
import './fold.css';

const Fold4 = () => {
  const features = [
 {
   title: "Omnichannel FNOL",
   description: "Via web forms or document uploads in Portals",
   icon: "🌐"
 },
 {
   title: "High‑precision OCR",
   description: "Auto‑extracts structured data with 99.9% accuracy",
   icon: "📄"
 },
 {
   title: "Policy & fraud risk engine",
   description: "Risk-aware adjudication",
   icon: "🛡️"
 },
 {
   title: "Straight‑Through Processing",
   description: "Up to 70% STP for routine claims",
   icon: "⚡"
 },
 {
   title: "Human-in-the-loop",
   description: "Manual handoff for complex cases",
   icon: "👥"
 },
 {
   title: "Compliance-ready",
   description: "Encrypted records, audit logs, GDPR/HIPAA-ready",
   icon: "🔒"
 },
 {
   title: "Real-time analytics",
   description: "Insights on cycle time, denial rates, cost savings",
   icon: "📊"
 }
];

  return (
    <div className="fold-content">
      <div className="features-container">
        <div className="section-header">
          <h2 className="section-title">Why Choose Beanbag AI?</h2>
          <p className="section-subtitle">Core Features</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={`feature-box ${index < 4 ? 'first-row' : 'second-row'}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Fold4;